let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d0w2N")).then(() => parcelRequire('jRxlC'));